import * as React from "react";
import { Box, TextField } from "@mui/material";
import CclDrawer from "../../../components/common/cclDrawer/cclDrawer";
import CclDrawerActionBar from "../../../components/common/cclDrawer/cclDrawerActionBar";
import CclButton from "../../../components/common/cclButtons/cclButton";
import { useCopyListMutation } from "../../../services/cclTokenedGroupReportsApi";
import { AccessEventListDetails } from "../../../services/types/accessEventTypes";
import useLogAccessEvent from "../../../hooks/useLogAccessEvent";
import { UserParticipantList } from "../../../services/types/groupReportTypes";
import { UserClaimsService } from "../../../services/currentUserService/currentUserService";

export type CopyListPanelProps = {
    open: boolean;
    selectedRows: any;
    onClose: () => void;
    onCopyList: () => void;
    snackbarHandler: (severity: string, message: string) => void;
};

export const CopyListPanel: React.FC<CopyListPanelProps> = (props) => {

    const [copyList] = useCopyListMutation();

    const { logEvent } = useLogAccessEvent();
    const claimservice = new UserClaimsService();

    const username = claimservice.GetCurrentUserEmail().split("@")[0].toUpperCase();

    const [listName, setListName] = React.useState<string>("");

    const copySelectedList = () => {
    
        const copyListRequest: UserParticipantList = {
            upL_ID: props.selectedRows.upL_ID,
            participantListName: listName,
            createdByDateTime: new Date().toISOString(),
            createdByUsername: username,
            createdByUsernameFullName: claimservice.GetCurrentUserName(),
            createdByGroupName: claimservice.GetCurrentUserGroup(),
        };

        copyList(copyListRequest)
            .unwrap()
            .then(() => {
                const eventDetails: AccessEventListDetails = {
                    listName: props.selectedRows.participantListName,
                }
                logEvent("GroupReportListCopied", eventDetails);
                props.snackbarHandler("success", "List copied");
                props.onCopyList();
            })
            .catch((error) => {
                console.error("Failed to copy the list: ", error);
                props.snackbarHandler("error", "List copy failed");
            });
    };
    
    return (
        <CclDrawer 
            title={"Copy List"} 
            open={props.open}
            onClose={props.onClose}
        >
            <TextField
                margin="normal" 
                label="List Name"
                fullWidth
                value={listName}
                onChange={(e) => setListName(e.target.value)}
            />
            <Box sx={{mt: "100%"}} />
            <CclDrawerActionBar >
                <CclButton onClick={copySelectedList} mode={"primary"}>Copy</CclButton>
                <CclButton onClick={props.onClose} mode={"secondary"}>Cancel</CclButton>
            </CclDrawerActionBar>
        </CclDrawer>
    );
};

export default CopyListPanel;
